import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

// Sub-paths, not the barrels: those drag the legacy coreOld graph into every grid test.
import { CopyValueButton } from 'core/elements/CopyValueButton';
import TextLine from 'core/elements/TextLine';
import { ITradeAgreement } from 'quotes/types';
import { Direction } from 'theme/enums';

// The copy action right after the code, so it reads as copying the code alone.
export const SpaCostSourceCell = ({ data, value }: ICellRendererParams<ITradeAgreement>) => {
  const { t } = useTranslation();

  if (!data) {
    return <>{value}</>;
  }

  return (
    <Stack sx={{ minWidth: 0 }}>
      <Stack direction={Direction.ROW} sx={{ alignItems: 'center', gap: 0.5, minWidth: 0 }}>
        <TextLine text={data.spaCostSource} textEllipsis bold sx={{ minWidth: 0 }} />

        {!!data.spaCostSource && (
          <CopyValueButton value={data.spaCostSource} label={t('tooltipCopySpaCostSource')} />
        )}
      </Stack>

      {!!data.spaCostSourceName && (
        <TextLine text={data.spaCostSourceName} textEllipsis isSubText />
      )}
    </Stack>
  );
};
